"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = void 0;
const validation_1 = require("../validation");
const chain_id_1 = require("./chain-id");
const network_1 = require("./network");
const nft_1 = require("./nft");
const nft_category_1 = require("./nft-category");
var Item;
(function (Item) {
    Item.schema = {
        type: 'object',
        properties: {
            id: {
                type: 'string',
            },
            name: {
                type: 'string',
            },
            thumbnail: {
                type: 'string',
            },
            url: {
                type: 'string',
            },
            category: nft_category_1.NFTCategory.schema,
            contractAddress: {
                type: 'string',
            },
            itemId: {
                type: 'string',
            },
            rarity: {
                type: 'string',
            },
            price: {
                type: 'string',
            },
            available: {
                type: 'integer',
            },
            isOnSale: {
                type: 'boolean',
            },
            creator: {
                type: 'string',
            },
            data: nft_1.NFT.schema.properties.data,
            network: network_1.Network.schema,
            chainId: chain_id_1.ChainId.schema,
            createdAt: {
                type: 'integer',
            },
            updatedAt: {
                type: 'integer',
            },
            reviewedAt: {
                type: 'integer',
            },
        },
        required: [
            'id',
            'name',
            'thumbnail',
            'url',
            'category',
            'contractAddress',
            'itemId',
            'rarity',
            'price',
            'available',
            'isOnSale',
            'creator',
            'data',
            'network',
            'chainId',
            'createdAt',
            'updatedAt',
        ],
    };
    Item.validate = validation_1.generateValidator(Item.schema);
})(Item = exports.Item || (exports.Item = {}));
//# sourceMappingURL=item.js.map